import React from 'react';

import { RefreshToken } from '@crossnokaye/typescript-sdk/models/components';
import { Card, CardContent, TableDensity } from '@crossnokaye/ux-common';
import {
  DataTable,
  DefaultCkTableOptions,
  useDataTable,
  UseDataTableInputOptions,
} from '@crossnokaye/ux-smarts';
import { ConditionalRender } from '@crossnokaye/ux-smarts';

import { columns } from '@/features/tokens/components/token-management-table/columns';

interface TokenManagementTableProps {
  data: RefreshToken[] | undefined;
}

// The default column sizing state for the desktop.
const DEFAULT_COLUMN_SIZING_STATE_DESKTOP = {
  name: 400,
  expiresAt: 150,
  actions: 100,
};

// The default column sizing state for the mobile. More constraints here
// because of space limitations.
const DEFAULT_COLUMN_SIZING_STATE_MOBILE = {
  name: 265,
  expiresAt: 100,
  actions: 100,
};

export const TokenManagementTable: React.FC<TokenManagementTableProps> = ({ data }) => {
  const options: UseDataTableInputOptions<RefreshToken> = {
    ...DefaultCkTableOptions,
    enableColumnResize: true,
    cache: {
      columnSizing: true,
      sort: true,
    },
    columnSizingState: {
      desktop: DEFAULT_COLUMN_SIZING_STATE_DESKTOP,
      mobile: DEFAULT_COLUMN_SIZING_STATE_MOBILE,
    },
    scrollContainerHeight: 'h-[75vh]',
    stickyHeader: true,
    tableDensity: TableDensity.DEFAULT,
  };
  const table = useDataTable<RefreshToken, RefreshToken>(
    'TOKEN_MANAGEMENT_TABLE',
    columns,
    data ?? [],
    options
  );

  return (
    <ConditionalRender
      condition={table.rows.length > 0}
      fallback={
        <Card>
          <CardContent className={'pt-6'}>{'No Tokens Found'}</CardContent>
        </Card>
      }
    >
      <DataTable
        rows={table.rows}
        headerCells={table.headerCells}
        settings={table.settings}
        tableId={table.dataTableId}
      />
    </ConditionalRender>
  );
};
